import { render } from "./UpdateProductsForm.vue?vue&type=template&id=41af08c4&scoped=true"
import script from "./UpdateProductsForm.vue?vue&type=script&lang=js"
export * from "./UpdateProductsForm.vue?vue&type=script&lang=js"

import "./UpdateProductsForm.vue?vue&type=style&index=0&id=41af08c4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41af08c4"]])

export default __exports__